import React from 'react';
import { Box, Typography, InputBase } from '@mui/material';
import SearchIcon from '../../../../assets/svg-fc/b2b/SearchIcon';
import { FilterBtnIconV2 } from '../../../../assets/svg-fc/FilterBtnIcon';
import CoreButtons from '../../../core-components/button/CoreButtons';
import { ChatFilterTypeEnum } from '../../../../constants/enums';
import './chatsHeader.scss';

interface ChatsHeaderProps {
  searchTerm: string;
  filterType: ChatFilterTypeEnum;
  activeFiltersCount?: number;
  totalUnreadChannelsCount?: number;
  onSearchChange: (value: string) => void;
  onFilterChange: (type: ChatFilterTypeEnum) => void;
  onFilterClick?: () => void;
}

const ChatsHeader: React.FC<ChatsHeaderProps> = ({
  searchTerm,
  onSearchChange,
  filterType,
  onFilterChange,
  totalUnreadChannelsCount = 0,
  onFilterClick,
  activeFiltersCount = 0,
}) => {
  return (
    <Box className="chatsHeader">
      <Typography className="chatsTitle">Messaging</Typography>
      <Box className="searchAndFilterRow">
        <Box className="searchContainer">
          <Box className="searchIcon">
            <SearchIcon />
          </Box>
          <InputBase
            placeholder="Search conversations"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="searchInput"
          />
        </Box>
        <Box className="filterIconButton" onClick={onFilterClick}>
          <Box className="filterIconWrapper">
            <CoreButtons startIcon={<FilterBtnIconV2 />} className="" />
            {activeFiltersCount > 0 && (
              <Box className="filterBadge">
                <Typography className="filterBadgeText">{activeFiltersCount}</Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <Box className="filterButtons">
        <Box
          className={`filterButtonChatPage ${filterType === ChatFilterTypeEnum.All ? 'active' : ''}`}
          onClick={() => onFilterChange(ChatFilterTypeEnum.All)}
        >
          <Typography>All</Typography>
        </Box>
        <Box
          className={`filterButtonChatPage ${filterType === ChatFilterTypeEnum.Unread ? 'active' : ''}`}
          onClick={() => onFilterChange(ChatFilterTypeEnum.Unread)}
        >
          <Typography>Unread
            {totalUnreadChannelsCount > 0 ? <span>&nbsp;({totalUnreadChannelsCount})</span> : null}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ChatsHeader;
